import * as React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function CustomModal({ open, handleClose, title, children }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {title && (
          <Typography variant="h6" component="h2" mb={2}>
            {title}
          </Typography>
        )}
        <Box mb={3}>{children}</Box>
        <Button variant="outlined" onClick={handleClose}>
          Close
        </Button>
      </Box>
    </Modal>
  );
}
